module.exports = __webpack_public_path__ + "static/media/carfixio-3.6fa1b241.jpg";